export const ENTITY_TYPES = {
  USER: 'user',
  USER_GROUP: 'userGroup',
} as const;

export type EntityType = (typeof ENTITY_TYPES)[keyof typeof ENTITY_TYPES];

export interface Entity {
  id: string;
  name: string;
  photo?: string;
  isServiceAccount: boolean;
  type: EntityType;
}
